module.exports = __webpack_public_path__ + "static/img/21.79380c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/21.png
// module id = bGhB
// module chunks = 1